import React, { FC } from 'react';
import {
    TwitterShareButton,
    TwitterIcon,
    LinkedinIcon,
    LinkedinShareButton,
    EmailShareButton,
    EmailIcon,
    FacebookIcon,
    FacebookShareButton,
    WhatsappShareButton,
    WhatsappIcon,
} from 'react-share';
import i18next from 'i18next';
import { Box } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { useStyles } from './styles';

interface Props {
    url: string;
    title: string;
    isCreator: boolean;
}

const ShareEvent: FC<Props> = ({ url, title, isCreator }) => {
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();

    const copyLinkToClipboard = () => {
        navigator.clipboard.writeText(window.location.href);
        enqueueSnackbar('Event link copied to clipboard', { variant: 'success' });
    };

    return (
        <>
            <h5 className={classes.title}>{i18next.t('EventPageComponentShareLiveEvent')}</h5>
            <div className={classes.buttonsContainer}>
                <FacebookShareButton
                    url={url}
                    title={
                        isCreator
                            ? `Check out the event i'm hosting. Get your ticket! "${title}"`
                            : `Check out the event I'm going to attend "${title}"!`
                    }
                >
                    <FacebookIcon size={42} round />
                </FacebookShareButton>
                <TwitterShareButton
                    url={url}
                    title={
                        isCreator
                            ? `Check out the event i'm hosting. Get your ticket! "${title}"`
                            : `Check out the event I'm going to attend "${title}"!`
                    }
                >
                    <TwitterIcon size={42} round />
                </TwitterShareButton>
                <LinkedinShareButton
                    url={url}
                    title={
                        isCreator
                            ? `Check out the event i'm hosting. Get your ticket! "${title}"`
                            : `Check out the event I'm going to attend "${title}"!`
                    }
                >
                    <LinkedinIcon size={42} round />
                </LinkedinShareButton>
                <WhatsappShareButton
                    url={url}
                    title={
                        isCreator
                            ? `Check out the event i'm hosting. Get your ticket! "${title}"`
                            : `Check out the event I'm going to attend "${title}"!`
                    }
                >
                    <WhatsappIcon size={42} round />
                </WhatsappShareButton>
                <EmailShareButton
                    url={url}
                    subject={title}
                    body={
                        isCreator
                            ? `Check out the event i'm hosting. Get your ticket! "${title}"`
                            : `Check out the event I'm going to attend "${title}"!`
                    }
                >
                    <EmailIcon size={42} round />
                </EmailShareButton>
            </div>
            <p className={classes.copyLinkText}>Or copy the link here:</p>
            <Box className={classes.clipboard} onClick={copyLinkToClipboard}>
                {window.location.href}
            </Box>
        </>
    );
};

export default ShareEvent;
